import React, { forwardRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { deletePHNumber } from "../../../apiclients/streamsapi_bridge.js";
import { useNavigate } from "react-router";

const DeletePhoneNumber = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    async function removeThisNumber(e) {
        console.log(props.phoneNum);
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let update = {
            reqid: 17,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            confirm: true,
            delete_phnum: props.phoneNum
        };
        console.log(update);
        let deletenum = await deletePHNumber(update);
        setTimeout(() => { props.setIsloading = false }, 1000);
        let deleteMsg = await deletenum.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "f_message",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            navigate("/PhoneNumbers", {
                state: { tab: "tab2" },
            });

        } else {
            localStorage.setItem("s_message", "Phone Number removed successfully.");
            navigate("/PhoneNumbers", {
                state: { tab: "tab2" },
            });
        }
        window.location.reload();
    }
    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("RemovePhonetxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisNumber(e)}>
                    {t("remove")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisNumber(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
        </>
    );
});

export default DeletePhoneNumber;
